const normalizedActorKey = (userUID) =>
  typeof userUID === "string" && userUID.length > 0
    ? `user:${encodeURIComponent(userUID)}`
    : "signed-out";

export const buildFeedCacheKey = ({ userUID, scope, orgId = null } = {}) => {
  const normalizedScope = scope === "org" ? "org" : scope;
  const scopeKey =
    normalizedScope === "org" ? `org:${orgId || "none"}` : normalizedScope;
  return `${normalizedActorKey(userUID)}|${scopeKey || "open"}`;
};

export const shouldForceOrganisationFeedScope = ({
  economyLoaded,
  tradeAllowed,
} = {}) => economyLoaded === true && tradeAllowed !== true;
